var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"display-4"},[_vm._v("KB App Manager")]),_c('div',{staticClass:"my-5"}),_c('CRow',{attrs:{"align-horizontal":"center"}},[_c('CCol',{attrs:{"col":"8"}},[_c('CRenderFunction',{attrs:{"flat":"","content-to-render":_vm.tiles}})],1)],1),_c('div',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }